// extracted by mini-css-extract-plugin
export default {"accountsListHeader":"list_accountsListHeader__Ok6wJ"};